import styled from 'styled-components';
import { IThemeProvider } from '../../styles/theme';

export const TableBody = styled.div`
    position: relative;
    min-height: 176px;
  ${({theme}: IThemeProvider) => `
      margin:  0 0 ${theme.layout.spacing.decy} 0;
   `}
`;

export const TableFooter = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${({theme}: IThemeProvider) => `
      margin:  0 ${theme.layout.spacing.centy} 0 ${theme.layout.spacing.centy};
   `}
`;
